import { MaterializedImageCollectionBlock } from '@fagmobler/sanity';

type ImageCollectionBlockProps = {
  block: MaterializedImageCollectionBlock;
};

export const ImageCollectionBlock = ({ block }: ImageCollectionBlockProps) => {
  return (
    <div>
      <h1>Image collection block</h1>
      <pre>{JSON.stringify(block, null, 2)}</pre>
    </div>
  );
};
